<div class="dialog">
    <div class="dialog_header">
        <a mat-dialog-close [class.disabled]="loading"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                <path id="ic_close"
                    d="M213.746-744.393l-6.441,6.436a1.459,1.459,0,0,1-1.063.457,1.406,1.406,0,0,1-1.046-.457,1.418,1.418,0,0,1-.45-1.054,1.449,1.449,0,0,1,.45-1.037l6.441-6.452-6.441-6.452a1.419,1.419,0,0,1-.441-1.037,1.473,1.473,0,0,1,.441-1.053,1.406,1.406,0,0,1,1.046-.457,1.485,1.485,0,0,1,1.063.441l6.441,6.452,6.458-6.452a1.431,1.431,0,0,1,1.046-.441,1.458,1.458,0,0,1,1.063.457,1.443,1.443,0,0,1,.433,1.053,1.448,1.448,0,0,1-.45,1.037l-6.441,6.452,6.441,6.452a1.419,1.419,0,0,1,.441,1.037,1.473,1.473,0,0,1-.441,1.054,1.406,1.406,0,0,1-1.046.457,1.406,1.406,0,0,1-1.046-.457Z"
                    transform="translate(-204.746 755.5)" fill="#999" />
            </svg>
        </a>
        <p class="m-0">{{"employees.Import Employees list"|translate}} <span class="fontRegular font-18 light-grey-color">(2/2)</span></p>
    </div>
    <div class="dialog_content" mat-dialog-content>

        <h4> {{"employees.Employees list imported successfully that contains"|translate}}</h4>

        <p class="success_count"><span>{{data?.total_success}}</span> {{"employees.Employees"|translate}} </p>

        <p class="warning" *ngIf="data?.total_errors"> {{"employees.Import_hint_2"|translate}}</p>

        <div class="list" *ngIf="data?.total_errors">
            <div class="title">
                {{data?.total_errors}} {{"employees.excluded employees"|translate}}
            </div>
            <div class="record" *ngFor="let item of data?.users_have_errors">
                <div class="name-with-image">
                    <div class="image-circle">
                        <!-- <img *ngIf="item.profileImg" [src]="item.profileImg" (error)='item.profileImg = ""'> -->
                        <span>{{ item.full_name | shortName }}</span>
                    </div>
                    <div class="name">
                        <h5 class="font-18 fontRegular mb-2">{{item.full_name|titlecase}}</h5>
                        <h5 class="font-14 email">{{item.email}}</h5>
                    </div>
                </div>
            </div>
        </div>



    </div>


    <div class="dialog_actions" mat-dialog-actions>
        <button mat-button mat-dialog-close [disabled]="loading" class="btn-secondary">{{"general.Cancel"|translate}}</button>
        <button mat-button class="btn-primary" (click)="onConfirm()"[disabled]="loading || !data?.total_success" [ngClass]="{'loading': loading}" >
            {{"employees.Submit"|translate}}
        </button>
    </div>
</div>